import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useAppDispatch } from "../../store/hooks";
import {
  getJDOpsCrops,
} from "../../slices/billingInvoices.slice";
import ProductsPricing from "./ProductsPricing";
import SeedsVariety from "./SeedsVarieties";
import OperationsCost from "./OperationsTabs";
import { styled } from '@mui/system';

import Revenue from "./Revenue";

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#1976D2', // Blue indicator
    height: '4px',
    borderRadius: '2px',
  },
});

const StyledTab = styled(Tab)({
  textTransform: 'none', 
  fontWeight: 'bold',
  fontSize: '16px',
  color: '#555', 
  '&.Mui-selected': {
    color: '#1976D2', // Blue color for selected tab
  },
  '&:hover': {
    color: '#1976D2', // Blue color on hover
    opacity: 0.8,
  },
});

const Pricing: React.FC = () => {
  const [value, setValue] = useState(0);
  const dispatch = useAppDispatch();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getJDOpsCrops()); // Get All Crops
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <StyledTabs value={value} onChange={handleChange}>
        <StyledTab label="Products"/>
        <StyledTab label="Seeds"/>
        <StyledTab label="Operations Cost"/>
        <StyledTab label="Harvest"/>
      </StyledTabs>
      {value === 0 && <ProductsPricing />}
      {value === 1 && <SeedsVariety/>}
      {value === 2 && <OperationsCost/>}
      {value ==3 && <Revenue/>}

    </Box>
  );
};

export default Pricing;
